import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'

Vue.config.productionTip = false
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
// window.Pusher.logToConsole = true;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_WEBSOCKETS_KEY,
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: false,
    disableStats: true,
});

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
